import React from "react";
import { RecoveryPasswordTemplate } from "../../Templates/RecoveryPasswordTemplate";

export const RecoveryPassword = () => {
  return <RecoveryPasswordTemplate />;
};
